// general
export const IS_DEV = process.env.NODE_ENV !== 'production';
export const API_URL = process.env.API_URL as string;
export const PUBLIC_PATH = process.env.PUBLIC_PATH as string;
export const NEXT_PUBLIC_TAG_MANAGER = process.env.NEXT_PUBLIC_TAG_MANAGER as string;
export const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN as string;

export const IMAGE_RESIZER_URL = 'https://static.platzi.com';
